module.exports = __webpack_public_path__ + "static/media/download-solid-full.a857b82b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/download-solid-full.svg
// module id = 2593
// module chunks = 0